<template>
  <nav class="pagination" role="navigation">
    <router-link :to="_getLink(pageNumber - 1)" class="pagination-previous" :disabled="pageNumber <= 1">{{"pagination.previous" | translate}}</router-link>
    <router-link :to="_getLink(pageNumber + 1)" class="pagination-next" :disabled="pageNumber >= totalPages">{{"pagination.next" | translate}}</router-link>
    <ul class="pagination-list">
      <li v-if="pageNumber > 2"><router-link :to="_getLink(1)" class="pagination-link" :class="{'is-current':pageNumber==1}">1</router-link></li>
      <li v-if="pageNumber > 3"><span class="pagination-ellipsis">&hellip;</span></li>
      <li v-if="pageNumber - 1 > 0"><router-link :to="_getLink(pageNumber - 1)" class="pagination-link">{{pageNumber - 1}}</router-link></li>
      <li><router-link :to="_getLink(pageNumber)" class="pagination-link is-current">{{pageNumber}}</router-link></li>
      <li v-if="pageNumber + 1 <= totalPages"><router-link :to="_getLink(pageNumber + 1)" class="pagination-link">{{pageNumber + 1}}</router-link></li>
      <li v-if="pageNumber < totalPages - 2"><span class="pagination-ellipsis">&hellip;</span></li>
      <li v-if="pageNumber < totalPages - 1"><router-link :to="_getLink(totalPages)" class="pagination-link">{{totalPages}}</router-link></li>
    </ul>
  </nav>
</template>
<script>
  export default {
    name: "pagination",
    props: {
      pageSize: {
        type: Number,
        required: false,
        default: 20
      }
    },
    data() {
      return {
        _pageNumber: Number(this.$route.query.page) || 1,
        _totalPages: 1
      };
    },
    computed: {
      pageNumber() {
        return Number(this.$route.query.page) || 1;
      },
      totalPages() {
        return this.$data._totalPages || 1;
      }
    },
    watch: {
      "$route.query.page": function (newValue) {
        this._triggerChange();
      },
      /*"$data._pageNumber": function (newValue) {
        this.$router.push(this.$route.name, { query: this._getQuery(newValue) });
      }*/
    },
    methods: {
      set(page, totalPages) {
        this.$data._totalPages = totalPages || 1;
        this.$data._pageNumber = this.$data._totalPages >= page ? page : totalPages;
      },
      _getLink(pageNumber) {
        return { name: this.$route.name, query: this._getQuery(pageNumber) };
      },
      _getQuery(pageNumber) {
        return Object.assign({}, this.$route.query, { page: pageNumber });
      },
      _triggerChange() {
        if (this.$data._pageNumber !== this.pageNumber) {
          this.$data._pageNumber = this.pageNumber;
          this.$emit("change", { page: this.pageNumber, size: this.pageSize });
        }
      }
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/pagination.vue